import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactProgressProps {
  total: number;
  completed: number;
  className?: string;
  color?: keyof typeof COLORS;
  backgroundColor?: keyof typeof COLORS;
}

const StyledDiv = styled.div<{
  color: NonNullable<TrueImpactProgressProps['color']>;
  backgroundColor: NonNullable<TrueImpactProgressProps['color']>;
  percentage: number;
}>`
  position: relative;
  .progress-background {
    width: 100%;
    height: 10px;
    border-radius: ${SPACERS.large};
    background-color: ${({ backgroundColor }) => COLORS[backgroundColor]};
  }
  .progress-foreground {
    top: 0;
    left: 0;
    height: 10px;
    position: absolute;
    border-radius: ${SPACERS.large};
    background-color: ${({ color }) => COLORS[color]};
    width: ${({ percentage }) => percentage}%;
  }
`;

const TrueImpactProgress: React.FC<TrueImpactProgressProps> = ({
  total,
  completed,
  className,
  color = 'success',
  backgroundColor = 'grayLight',
}) => {
  const percentage = (completed / total) * 100;
  const finalPercentage = percentage > 100 ? 100 : percentage;
  return (
    <StyledDiv
      color={color}
      className={className}
      backgroundColor={backgroundColor}
      percentage={finalPercentage}
    >
      <div className="progress-background" />
      <div className="progress-foreground" />
    </StyledDiv>
  );
};

export default TrueImpactProgress;
